export interface Airport {
  dateTime: string;
  city: string;
  airportCode: string;
  airport: string;
}

export enum JourneyType {
  RETURN = 'return',
  ONEWAY = 'oneway',
  COMPLEX = 'complex',
}
